import { createEntitySelectionStore } from './factories/createEntitySelectionStore';

/**
 * Lightweight store for thread UI state only
 * - selectedThreadId: Currently selected/viewed thread
 * Server data is managed by TanStack Query
 */
export const useThreadUIStore = createEntitySelectionStore('thread');
